import { render, staticRenderFns } from "./DomainTablesConfiguration.vue?vue&type=template&id=cdb67b86&scoped=true&"
import script from "./DomainTablesConfiguration.vue?vue&type=script&lang=js&"
export * from "./DomainTablesConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DomainTablesConfiguration.vue?vue&type=style&index=0&id=cdb67b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb67b86",
  null
  
)

export default component.exports